import { render, staticRenderFns } from "./copyable-text.vue?vue&type=template&id=c8fd20f4&scoped=true"
import script from "./copyable-text.vue?vue&type=script&lang=js"
export * from "./copyable-text.vue?vue&type=script&lang=js"
import style0 from "./copyable-text.vue?vue&type=style&index=0&id=c8fd20f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fd20f4",
  null
  
)

export default component.exports